// src/components/BirthdayPopup/BirthdayPopup.jsx
import { useEffect, useState } from 'react';
import notificationService from '../../services/notification.service';

const BirthdayPopup = () => {
  const [show, setShow] = useState(false);
  const [name, setName] = useState('');

  useEffect(() => {
    let mounted = true;
    // Only show once per day per browser
    const key = `bday_shown_${new Date().toISOString().split('T')[0]}`;
    if (localStorage.getItem(key)) return;

    notificationService.checkMyBirthday()
      .then(res => {
        if (mounted && res.success && res.data.isBirthday) {
          setName(res.data.firstName || '');
          setShow(true);
          localStorage.setItem(key, '1');
        }
      })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
      }}
      onClick={() => setShow(false)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff', borderRadius: 16, padding: '40px 32px', maxWidth: 420,
          textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', position: 'relative',
        }}
      >
        <div style={{ fontSize: 64, marginBottom: 8 }}>🎂</div>
        <h2 style={{ margin: '0 0 8px', color: '#2e7d32', fontWeight: 800 }}>
          Happy Birthday{name ? `, ${name}` : ''}! 🎉
        </h2>
        <p style={{ color: '#555', fontSize: 15, margin: '0 0 24px' }}>
          The whole Haritpane Agro team wishes you a fantastic day filled with joy and success!
        </p>
        <button
          onClick={() => setShow(false)}
          className="btn btn-primary"
          style={{ padding: '10px 28px' }}
        >
          Thank you! 🙏
        </button>
      </div>
    </div>
  );
};

export default BirthdayPopup;